import React from 'react';
import {
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';

import { MOCK_USER } from '@models/user.model';

import { LSKeys, LocalStorage } from '../localStorage';
import { AppRoutes } from './_routes';

const AppCore: React.FC = () => {
  const getUser = () => {
    return new Promise((resolve, _) => {
      const loggedIn = !!LocalStorage.get(LSKeys.USER_LOGGED_IN);
      resolve(loggedIn ? MOCK_USER : null);
    });
  };

  const router = createBrowserRouter(
    createRoutesFromElements(AppRoutes(getUser))
  );

  return (
    <>
      <div className="nsc-background">
        <div className="nsc-background__gradient" />
        <div className="nsc-background__grain" />
      </div>
      <RouterProvider router={router} />

      {/* Main app loading */}
      {/* <LoadingIntro
        onAnimStart={() => setIsLoadingContent(true)}
        onAnimEnd={() => {}}
      /> */}
    </>
  );
};

export default AppCore;
